import React, { Component } from 'react';

import { Polygon } from 'google-maps-react';


class PruningArea extends Component {

    componentDidMount() {
        this.loadPruningAreasList();
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.pruningList.length !== nextProps.pruningList.length
            || this.props.zoomLevel !== nextProps.zoomLevel
            || this.props.showPruningLayer !== nextProps.showPruningLayer) {
            return true;
        }
        else {
            return false;
        }
    }

    componentDidUpdate() {
        this.loadPruningAreasList();
    }

    loadPruningAreasList = () => {
        let resultList = [];

        if (this.props.showPruningLayer
            && this.props.pruningList
            && this.props.pruningList.length > 0
            && this.props.zoomLevel > 0) {
            this.props.pruningList.forEach((prune, index) => {
                let pruneArea =
                    <Polygon
                        key={index}
                        paths={prune.polygon}
                        position={prune.position}
                        strokeColor="#FF0000"
                        strokeOpacity={0.8}
                        strokeWeight={1}
                        fillColor="#03ad44"
                        fillOpacity={0.7}
                        clicable
                        onClick={this.props.onPruningClick}
                        ohl={prune.ohl}
                        span={prune.span}
                        isUrgent={prune.isUrgent}
                        vegetationType={prune.vegetationType}
                        height={prune.height}
                        contact={prune.contact}
                    />
                resultList.push(pruneArea);
            });
        }

        this.props.sendChildElementDataToState(this.props.stateElementName, resultList);
    }

    render() {
        return null;
    }
}

export default PruningArea;

